import { format } from "date-fns";
// 受け取った日付をYYYY-MM-01の書式で返す
export default function monthAndYearFormat(date = new Date()) {
    return format(date, "yyyy-MM-01");
}
